import {
  CalendarIcon,
  ChartBarIcon,
  InformationCircleIcon,
  ShareIcon
} from '@heroicons/react/outline'
import "./Navbar.css"
import { ENABLE_ARCHIVED_GAMES } from '../../constants/settings'
import { GAME_TITLE } from '../../constants/strings'
import { shareStatus } from '../../lib/share'
// import { useState } from 'react'
//import { Link } from 'react-router-dom'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsDatePickerModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
  solution: string
  guesses: string[]
  isGameLost: boolean
  isHardMode: boolean
  isDarkMode: boolean
  isHighContrastMode: boolean
  handleShareToClipboard: () => void
  handleShareFailure: () => void
  setIsShareModalOpen: (value: boolean) => void
}

export const Navbar = (
  {
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsDatePickerModalOpen,
  setIsSettingsModalOpen,
  solution,
  guesses,
  isGameLost,
  isHardMode,
  isDarkMode,
  isHighContrastMode,
  handleShareToClipboard,
  handleShareFailure,
  setIsShareModalOpen,
}: Props) => {
  // const [isActive, setActive]=useState(false)

  return (
    <div className="navbar">
      <div className="container"  >
        {/* <button className='hamburger' onClick={()=>setActive(!isActive)}>
        <span className='bar' style={{height:'4px', width:'35px', backgroundColor:'#000', display:'block', marginBottom:'5px'}}></span>
        <span className='bar' style={{height:'4px', width:'35px', backgroundColor:'#000', display:'block',  marginBottom:'5px'}}></span>
        <span className='bar' style={{height:'4px', width:'35px', backgroundColor:'#000', display:'block'}}></span>
      </button> */}
      <div className="navbar-content px-5 short:h-auto" >
        <div className="flex">
          <InformationCircleIcon
            className="h-6 w-6 cursor-pointer dark:stroke-white"
            onClick={() => setIsInfoModalOpen(true)}
          />
          {ENABLE_ARCHIVED_GAMES && (
            <CalendarIcon
              className="ml-3 h-6 w-6 cursor-pointer dark:stroke-white"
              onClick={() => setIsDatePickerModalOpen(true)}
            />
          )}
        </div>
        
        <p className="center-heading text-xl font-bold dark:text-white uppercase text-light-up">{GAME_TITLE}</p>
        <div className="right-icons">
          <ChartBarIcon
            className="mr-3 h-6 w-6 cursor-pointer dark:stroke-white"
            onClick={() => setIsStatsModalOpen(true)}
          />
          <ShareIcon
            className="mr-3 h-6 w-6 cursor-pointer dark:stroke-white"
            onClick={() => {
                shareStatus(
                solution,
                guesses,
                isGameLost,
                isHardMode,
                isDarkMode,
                isHighContrastMode,
                handleShareToClipboard,
                handleShareFailure,
                )
                setIsShareModalOpen(true)
                // { console.log('shareStatus',solution)}
              }}
          />
        </div>

        {/* <div className="right-icons">
          <ShareIcon
            className="mr-3 h-6 w-6 cursor-pointer dark:stroke-white"
            onClick={() => handleShare}
          />
        </div> */}

      </div>
      <span className='blank' style={{display:'block'}}></span>
      </div>
      
      {/* <div className={`${isActive ? "sidebar" :"hidebar"}`} >
            <Link to='/login'>
            <button className='login' style={{color:"#333", fontSize:"18px", padding:"7px 20px", display:"block", width:"100%", background:"#fff", marginBottom:"16px"}}>login</button>
            </Link>   
            <Link to='/signup'>
            <button className='signup' style={{color:"#333", fontSize:"18px", padding:"7px 20px", display:"block", width:"100%",  background:"#fff"}}>signup</button>
            </Link>
            
      </div> */}
    </div>
  )
}
//line 45 navigation setting